import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Project } from "../Types/Project/ProjectInterface";
import { fetchServiceProjects } from "../Thunks/layoutThunks";

interface LayoutSliceState {
    loadingServiceProjects: boolean;
    serviceProjects: Project[];
    errorServiceProjects: string | null;
}

// set inital valus
const initialState: LayoutSliceState = {
    loadingServiceProjects: false,
    serviceProjects: [],
    errorServiceProjects: ''
}

// set state value for api response
const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
        builder
            /* Service projects */
            .addCase(fetchServiceProjects.pending, state => {
                state.loadingServiceProjects = true;
                state.errorServiceProjects = null;
            })
            .addCase(fetchServiceProjects.fulfilled, (state, action: PayloadAction<Project[]>) => {
                state.loadingServiceProjects = false;
                state.serviceProjects = action.payload;
            })
            .addCase(fetchServiceProjects.rejected, (state, action) => {
                state.loadingServiceProjects = false;
                state.errorServiceProjects = action.error.message ?? "Failed to fetch projects.";
            });
    }
})

export default layoutSlice.reducer